import Axios from 'axios'
import { URL } from '../constants/Urls'

export const sendQuery = async (data) => {
  return await Axios.post(URL.SEND_QUERY, data)
}
